export interface TPasswordChangePresentationModel {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export interface IPasswordChangePresentationModel
  extends TPasswordChangePresentationModel {}

const PasswordChangePresentationModel = (
  data?: any
): IPasswordChangePresentationModel => {
  return {
    oldPassword: data ? data.oldPassword : "",
    newPassword: data ? data.newPassword : "",
    confirmNewPassword: data ? data.confirmNewPassword : ""
  };
};
export default PasswordChangePresentationModel;
